var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-descriptions',{attrs:{"bordered":"","size":"small","title":"","column":3}},_vm._l((_vm.detail),function(item){return _c('a-descriptions-item',{attrs:{"label":item.name}},[_vm._v(_vm._s(item.vaules))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }